<template>
  <div class="navbar">
    <div style="display: none;">{{ medicalSocketIn0 }}</div>
    <!-- 折叠，收起 左侧导航的图标 -->
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <error-log class="errLog-container right-menu-item"/> -->

        <el-tooltip content="通知" effect="dark" placement="bottom">
          <router-link to="/msgMan/:type" class="top-right-item">
            <el-badge v-if="userMsgNum != 0" :value="userMsgNum" class="item">
              <i class="el-icon-bell"></i>
            </el-badge>
            <i v-else style="margin-top: 2px" class="el-icon-bell"></i>
          </router-link>
        </el-tooltip>

        <el-tooltip
          :content="$t('navbar.screenfull')"
          effect="dark"
          placement="bottom"
        >
          <screenfull class="screenfull right-menu-item" />
        </el-tooltip>

        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select class="international right-menu-item"/>
        </el-tooltip> -->

        <!-- <lang-select class="international right-menu-item"/> -->

        <!-- <el-tooltip :content="$t('navbar.theme')" effect="dark" placement="bottom">
          <theme-picker class="theme-switch right-menu-item"/>
        </el-tooltip> -->
      </template>

      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <span style="margin-right: 16px; float: left"
            >欢迎您：{{ userName }}</span
          >

          <img
            style="float: left"
            src="static/image/user_avatar.png"
            class="user-avatar"
          />
          <!-- <img style="float: left" src="static/image/user_avatar.png" class="user-avatar"> -->
          <i style="float: left" class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item style="width: 140px">
              <span style="display: block; padding: 4px 10px">首页</span>
            </el-dropdown-item>
          </router-link>

          <!-- <el-dropdown-item divided>
            <span style="display:block;padding: 4px 10px;" @click="logout">个人信息</span>
          </el-dropdown-item> -->

          <el-dropdown-item>
            <span style="display: block; padding: 4px 10px" @click="showPwd"
              >修改密码</span
            >
          </el-dropdown-item>

          <!-- <el-dropdown-item>
            <el-upload
              class=""
              action=''
              :show-file-list="false"
              :before-upload="uploadBg1">
              
              <span style="display:block;padding: 4px 10px;" >修改头像</span>

            </el-upload>
          </el-dropdown-item> -->

          <el-dropdown-item divided>
            <span style="display: block; padding: 4px 10px" @click="logout"
              >退出登录</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-if="tsocket" class="clearfix fr" style="margin-top: 10px; margin-right: 30px;">
      
      <div
        
        @click="txtClick('转邮寄待确认')"
        class="fr fs20 lh32 name-wrapper"
        style="margin-left: 30px;font-size: 26px;color: red"
      >
        转邮寄待确认:{{ waitTurnSendNum || 0 }}
      </div>
      <div
        @click="txtClick('今日待打印')"
        class="fr lh32 name-wrapper"
        style="margin-left: 30px;font-size: 26px;color: red"
      >
        今日待打印:{{ waitPrintNum || 0 }}
      </div>
      <div
        @click="txtClick('今日待审核')"
        class="fr fs20 lh32 name-wrapper"
        style="margin-left: 30px;font-size: 26px;color: red"
      >
        今日待审核:{{ waitAuthNum || 0 }}
      </div>
      <!-- 暂时不加点击事件 @click="txtClick('超期待审数')" -->
       <div
        v-if="routeFullPath.indexOf('appointReceiveHandle') >= 0"
        class="fr fs20 lh32 name-wrapper"
        style="font-size: 26px;color: red"
      >
        超期待审数:{{ chaoqidaishenhe || 0 }}
      </div>
      
    </div>

    <!-- 修改密码 弹窗 -->
    <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="pwdState"
      append-to-body
      width="600px"
      top="30px"
    >
      <el-form
        ref="pwdRef"
        :rules="pwdRules"
        :model="pwdData"
        label-position="right"
        label-width="120px"
        style="width: 470px"
      >
        <el-form-item label="原密码" prop="oldPwd">
          <el-input
            v-model="pwdData.oldPwd"
            placeholder="请输入原密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pwd">
          <el-input
            v-model="pwdData.pwd"
            placeholder="请输入新密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input
            v-model="pwdData.pwd2"
            placeholder="请输入确认密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdState = false" icon="el-icon-back"
          >取消</el-button
        >
        <el-button
          type="success"
          :loading="dialogLoading"
          @click="pwdSubFunc"
          icon="el-icon-check"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 通用
import * as utils from "@/utils";

import Cookie from "js-cookie";

import { uploadImg } from "@/utils/uploadImg";

import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
// import SizeSelect from '@/components/SizeSelect'
import LangSelect from "@/components/LangSelect";
import ThemePicker from "@/components/ThemePicker";

// 接口
import { updatePwd, uploadAvatar } from "@/api/login";
import { findSysUser } from "@/api/staffMan";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    // SizeSelect,
    LangSelect,
    ThemePicker
  },
  data() {
    return {
      userInfo: {},

      userName: "",
      userAvatar: "",

      // 密码弹窗
      dialogLoading: false,
      pwdState: false,
      pwdData: {
        userId: "",
        oldPwd: "",
        pwd: "",
        pwd2: ""
      },
      pwdRules: {
        oldPwd: [{ required: true, message: "必填字段", trigger: "blur" }],
        pwd: [{ required: true, message: "必填字段", trigger: "blur" }],
        pwd2: [{ required: true, message: "必填字段", trigger: "blur" }]
      },

      routeFullPath: '',

      tsocket: "",
      tsocketQuery: '',
      waitAuthNum: "",
      waitPrintNum: "",
      waitTurnSendNum: "",
      chaoqidaishenhe: "",
      socketInterval: null,
    };
  },
  computed: {
    ...mapGetters(["sidebar", "name", "avatar", "device"]),
    userMsgNum() {
      let userMsgNum = this.$store.getters.userMsgNum;
      if (!userMsgNum) {
        userMsgNum = Cookie.get("userMsgNum");
      }
      return userMsgNum;
    },
    medicalSocketIn0() {
      if (this.$store.state.medicalSocketIn) {
        this.tsocketQuery= JSON.parse(this.$store.state.medicalSocketIn);
        this.initWebsocket0()
      } 
      return this.$store.state.medicalSocketIn;
    }

  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        console.log("====newVal", newVal);
        this.routeFullPath = newVal.fullPath;

        this.closeSocket();
        this.$store.commit('setMedicalSocketIn', '');
      },
      immediate: true

    }
  },

  created() {
    this.$ELEMENT.size = "mini";
    this.$store.commit("SET_SIZE", "mini");

    this.userName = window.localStorage.userName;
    this.pwdData.userId = window.localStorage.userId;
    this.userInfo = JSON.parse(window.localStorage.ERPUserInfo);

    this.getUserInfo(window.localStorage.userId);

    setTimeout(() => {
      console.log('====this.$store.state', this.$store.state)
    },2000)
  },
  methods: {
    // ==== 病历 socket
    initWebsocket0() {
      if (this.socketInterval) {
        clearInterval(this.socketInterval);
      }
      this.initWebsocket();
      this.socketInterval = setInterval(() => {
        this.initWebsocket();
      }, 1000 * 60 * 10);
    },
    closeSocket() {
      if (this.socketInterval) {
        clearInterval(this.socketInterval);
      }
      if (this.tsocket) {
        this.tsocket.close();
        this.tsocket = null;
      }
    },
    initWebsocket() {
      if (this.tsocket) {
        this.tsocket.close();
        this.tsocket = null;
      }
      let wsUrl = `ws://192.168.1.189:8014/api/auditPrintListpoint/${
          this.tsocketQuery.projectId
        }/${this.userInfo.id}`;
      if (location.host.indexOf("192.168.1.251") >= 0) {
        wsUrl = `ws://192.168.1.251:8014/api/auditPrintListpoint/${
          this.tsocketQuery.projectId
        }/${this.userInfo.id}`;
      } else if (location.host.indexOf("erp.wlines.cn") >= 0) {
        wsUrl = `wss://erp.wlines.cn/caseapi/auditPrintListpoint/${
          this.tsocketQuery.projectId
        }/${this.userInfo.id}`;
      }
      this.tsocket = new WebSocket(wsUrl);

      this.tsocket.onopen = function(event) {};
      this.tsocket.onmessage = event => {
        this.dataLoading = false;
        if (event.data) {
          let data = JSON.parse(event.data);
          this.waitAuthNum = data.daishenhe;
          this.waitPrintNum = data.daidayin;
          this.waitTurnSendNum = data.daiqueren;
          this.chaoqidaishenhe = data.chaoqidaishenhe;
        }
      };

      this.tsocket.onclose = function(event) {
        console.log("WebSocket连接已关闭！", event);
      };

      this.tsocket.onerror = function(error) {
        console.error("WebSocket连接错误：", error);
      };
    },
    txtClick(str) {
      if (this.routeFullPath.indexOf('appointReceiveHandle') >= 0) {
        if (str == '今日待审核' || str == '今日待打印') {
          let obj = {
            type: str
          };
          this.$store.commit("setMedicalSocket", JSON.stringify(obj));
          setTimeout(() => {
            this.$store.commit('setMedicalSocket', '');
          }, 100 );
        } else {
          this.$router.push({
            path: '/jyt/medicalRecord/businessHan/turnSendQuery',
          })
        }
      }
      if (this.routeFullPath.indexOf('turnSendQuery') >= 0) {
        if (str == '今日待审核' || str == '今日待打印') {
          this.$router.push({
            path: '/jyt/medicalRecord/businessHan/appointReceiveHandle',
          })
          setTimeout(() => {
            let obj = {
              type: str
            };
            this.$store.commit("setMedicalSocket", JSON.stringify(obj));
            setTimeout(() => {
              this.$store.commit('setMedicalSocket', '');
            }, 100 );
          }, 1000)
        } else {
          let obj = {
            type: str
          };
          this.$store.commit("setMedicalSocket", JSON.stringify(obj));
          setTimeout(() => {
            this.$store.commit('setMedicalSocket', '');
          }, 100 );
        }
      }
    },

    //////
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    // 显示弹窗
    showPwd() {
      this.pwdState = true;
    },
    // 修改密码
    pwdSubFunc() {
      this.$refs["pwdRef"].validate(valid => {
        if (valid) {
          let oldPwd = this.pwdData.oldPwd;
          let pwd = this.pwdData.pwd;
          let pwd2 = this.pwdData.pwd2;

          // 判断密码长度 6 - 15位
          const pwdReg = /^[a-zA-Z0-9_-]{6,15}$/;

          if (!pwdReg.test(pwd)) {
            this.$message({
              type: "warning",
              message: "请输入6至15位新密码，可包含字母、数字、下划线、减号"
            });
            return false;
          }
          // 两密码是否相等
          if (pwd != pwd2) {
            this.$message({
              type: "warning",
              message: "两次密码输入不一致，请重新输入"
            });
            return false;
          }
          this.dialogLoading = true;
          // 修改密码接口
          updatePwd(this.pwdData).then(res => {
            this.dialogLoading = false;

            let code = res.data.code;
            let msg = res.data.msg;
            if (code == "200") {
              this.pwdState = false;
              this.$nextTick(() => {
                this.$refs["pwdRef"].clearValidate();
              });
              this.$message.success("修改成功，请重新登录");
              window.localStorage.Token = "";
              this.$router.push("/login");
            } else {
              this.$message.error(msg);
            }
          });
        }
      });
    },
    // 修改头像
    uploadBg1(file) {
      let loading = this.$loading({
        lock: true,
        text: "提交中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      console.log("准备上传阿里", file);
      uploadImg(file, "hr/data/hr_userAvatar").then(imgUrl => {
        loading.close();
        console.log("阿里返回", imgUrl);
        uploadAvatar({ avatar: imgUrl }).then(res1 => {
          let res = res1.data;
          console.log("上传头像返回值", res);

          if (res.code == 200) {
            this.userAvatar = imgUrl;
            this.$message.success("修改成功");
          }
        });
      });
    },
    // 退出登录
    logout() {
      if (window.workbench) {
        if (
          Cookie.get("workbenchCode") >= 1 &&
          Cookie.get("workbenchCode") <= 5
        ) {
          window.workbench.logOut();
        }
      }
      window.localStorage.userId = "";
      window.localStorage.Token = "";
      window.localStorage.userName = "";
      this.$router.push({ path: "/login" });
      this.$store.commit("SET_ROUTERS", []);
      window.localStorage.userRoles = "";

      console.log("==再次刷新页面");
      location.reload();
      // setTimeout(() => {
      //   console.log("==再次刷新页面");
      //   location.reload();
      // }, 100);
      // store.getters.addRouters
      // this.$store.dispatch('LogOut').then(() => {
      //   location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      // })
    },

    // 获取用户信息
    getUserInfo(userId) {
      // let loading = this.$loading({
      //   lock: true,
      //   text: '提交中...',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      findSysUser(userId).then(res1 => {
        // loading.close()
        let res = res1.data;
        if (res.code == 200) {
          this.userAvatar = res.data.avatar;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.top-right-item {
  margin-right: 16px;
  margin-top: 19px;
  float: left;
  font-size: 20px;
  color: #666;
  line-height: 20px;
  height: 20px;
}
</style>
